/* eslint-disable */
/* oxlint-disable */
/* prettier-ignore-file */
// @ts-nocheck
// This file is auto-generated. Do not edit manually.
// Run 'pnpm codegen' to regenerate this file.

import { Symbol, SymbolJsonValue, Symbol_fromJsonValue, Symbol_toJsonValue, PositionKey, PositionKeyJsonValue, PositionKey_fromJsonValue, PositionKey_toJsonValue, AccountPositionKey, AccountPositionKeyJsonValue, AccountPositionKey_fromJsonValue, AccountPositionKey_toJsonValue } from './prex.v2.r230522.id';
import { PrexDecimal, PrexDecimalJsonValue, PrexDecimal_fromJsonValue, PrexDecimal_toJsonValue, PrexTimestamp, PrexTimestampJsonValue, PrexTimestamp_fromJsonValue, PrexTimestamp_toJsonValue } from './prex.shared.primitives';

export interface Position {
  accountId: number;
  positionId: string;
  symbol: Symbol;
  slot: number;
  marginType: MarginType;
  cumFee: PrexDecimal;
  cumFundingFee: PrexDecimal;
  cumTradingFee: PrexDecimal;
  initLeverage: number;
  effectiveLeverage: PrexDecimal;
  initPositionMargin: PrexDecimal;
  initMarginReserved: PrexDecimal;
  isolatedMarginInitial: PrexDecimal;
  isolatedMarginAdded: PrexDecimal;
  isolatedMarginRealizedFee: PrexDecimal;
  isolatedMarginExecutedFee: PrexDecimal;
  position: PrexDecimal;
  avgEntryPrice: PrexDecimal;
  liquidationPrice?: PrexDecimal;
  unrealizedPnl: PrexDecimal;
  unrealizedPnlMark: PrexDecimal;
  unrealizedPnlLast: PrexDecimal;
  unrealizedPnlBbo: PrexDecimal;
  grossRealizedPnl: PrexDecimal;
  netRealizedPnl: PrexDecimal;
  netPnl: PrexDecimal;
  netPnlMark: PrexDecimal;
  netPnlLast: PrexDecimal;
  netPnlBbo: PrexDecimal;
  midPrice: PrexDecimal;
  bidPrice: PrexDecimal;
  askPrice: PrexDecimal;
  bboPriceTimestamp: PrexTimestamp;
  flipComboCount: number;
  airdropType?: PositionAirdropType;
  lockedUntil?: PrexTimestamp;
  pnlTopPercentile?: number;
  boostCumPnl: PrexDecimal;
  buyableBoosts: ProfitBoost[];
  boostExpiryTimestamp?: PrexTimestamp;
  boostDailyRemainingCount: number;
  boostDailyLimitCount: number;
  openTime: PrexTimestamp;
  options: PositionOption[];
}
export interface PositionJsonValue {
  accountId: number;
  positionId: string;
  symbol: SymbolJsonValue;
  slot: number;
  marginType: MarginTypeJsonValue;
  cumFee: PrexDecimalJsonValue;
  cumFundingFee: PrexDecimalJsonValue;
  cumTradingFee: PrexDecimalJsonValue;
  initLeverage: number;
  effectiveLeverage: PrexDecimalJsonValue;
  initPositionMargin: PrexDecimalJsonValue;
  initMarginReserved: PrexDecimalJsonValue;
  isolatedMarginInitial: PrexDecimalJsonValue;
  isolatedMarginAdded: PrexDecimalJsonValue;
  isolatedMarginRealizedFee: PrexDecimalJsonValue;
  isolatedMarginExecutedFee: PrexDecimalJsonValue;
  position: PrexDecimalJsonValue;
  avgEntryPrice: PrexDecimalJsonValue;
  liquidationPrice?: PrexDecimalJsonValue;
  unrealizedPnl: PrexDecimalJsonValue;
  unrealizedPnlMark: PrexDecimalJsonValue;
  unrealizedPnlLast: PrexDecimalJsonValue;
  unrealizedPnlBbo: PrexDecimalJsonValue;
  grossRealizedPnl: PrexDecimalJsonValue;
  netRealizedPnl: PrexDecimalJsonValue;
  netPnl: PrexDecimalJsonValue;
  netPnlMark: PrexDecimalJsonValue;
  netPnlLast: PrexDecimalJsonValue;
  netPnlBbo: PrexDecimalJsonValue;
  midPrice: PrexDecimalJsonValue;
  bidPrice: PrexDecimalJsonValue;
  askPrice: PrexDecimalJsonValue;
  bboPriceTimestamp: PrexTimestampJsonValue;
  flipComboCount: number;
  airdropType?: PositionAirdropTypeJsonValue;
  lockedUntil?: PrexTimestampJsonValue;
  pnlTopPercentile?: number;
  boostCumPnl: PrexDecimalJsonValue;
  buyableBoosts: ProfitBoostJsonValue[];
  boostExpiryTimestamp?: PrexTimestampJsonValue;
  boostDailyRemainingCount: number;
  boostDailyLimitCount: number;
  openTime: PrexTimestampJsonValue;
  options: PositionOptionJsonValue[];
}
export function Position_fromJsonValue(json: PositionJsonValue): Position {
  return {
    accountId: json['accountId'],
    positionId: json['positionId'],
    symbol: Symbol_fromJsonValue(json['symbol']),
    slot: json['slot'],
    marginType: MarginType_fromJsonValue(json['marginType']),
    cumFee: PrexDecimal_fromJsonValue(json['cumFee']),
    cumFundingFee: PrexDecimal_fromJsonValue(json['cumFundingFee']),
    cumTradingFee: PrexDecimal_fromJsonValue(json['cumTradingFee']),
    initLeverage: json['initLeverage'],
    effectiveLeverage: PrexDecimal_fromJsonValue(json['effectiveLeverage']),
    initPositionMargin: PrexDecimal_fromJsonValue(json['initPositionMargin']),
    initMarginReserved: PrexDecimal_fromJsonValue(json['initMarginReserved']),
    isolatedMarginInitial: PrexDecimal_fromJsonValue(json['isolatedMarginInitial']),
    isolatedMarginAdded: PrexDecimal_fromJsonValue(json['isolatedMarginAdded']),
    isolatedMarginRealizedFee: PrexDecimal_fromJsonValue(json['isolatedMarginRealizedFee']),
    isolatedMarginExecutedFee: PrexDecimal_fromJsonValue(json['isolatedMarginExecutedFee']),
    position: PrexDecimal_fromJsonValue(json['position']),
    avgEntryPrice: PrexDecimal_fromJsonValue(json['avgEntryPrice']),
    liquidationPrice: json['liquidationPrice'] != null ? PrexDecimal_fromJsonValue(json['liquidationPrice']) : undefined,
    unrealizedPnl: PrexDecimal_fromJsonValue(json['unrealizedPnl']),
    unrealizedPnlMark: PrexDecimal_fromJsonValue(json['unrealizedPnlMark']),
    unrealizedPnlLast: PrexDecimal_fromJsonValue(json['unrealizedPnlLast']),
    unrealizedPnlBbo: PrexDecimal_fromJsonValue(json['unrealizedPnlBbo']),
    grossRealizedPnl: PrexDecimal_fromJsonValue(json['grossRealizedPnl']),
    netRealizedPnl: PrexDecimal_fromJsonValue(json['netRealizedPnl']),
    netPnl: PrexDecimal_fromJsonValue(json['netPnl']),
    netPnlMark: PrexDecimal_fromJsonValue(json['netPnlMark']),
    netPnlLast: PrexDecimal_fromJsonValue(json['netPnlLast']),
    netPnlBbo: PrexDecimal_fromJsonValue(json['netPnlBbo']),
    midPrice: PrexDecimal_fromJsonValue(json['midPrice']),
    bidPrice: PrexDecimal_fromJsonValue(json['bidPrice']),
    askPrice: PrexDecimal_fromJsonValue(json['askPrice']),
    bboPriceTimestamp: PrexTimestamp_fromJsonValue(json['bboPriceTimestamp']),
    flipComboCount: json['flipComboCount'],
    airdropType: json['airdropType'] != null ? PositionAirdropType_fromJsonValue(json['airdropType']) : undefined,
    lockedUntil: json['lockedUntil'] != null ? PrexTimestamp_fromJsonValue(json['lockedUntil']) : undefined,
    pnlTopPercentile: json['pnlTopPercentile'] != null ? json['pnlTopPercentile'] : undefined,
    boostCumPnl: PrexDecimal_fromJsonValue(json['boostCumPnl']),
    buyableBoosts: json['buyableBoosts'].map((x: any) => ProfitBoost_fromJsonValue(x)),
    boostExpiryTimestamp: json['boostExpiryTimestamp'] != null ? PrexTimestamp_fromJsonValue(json['boostExpiryTimestamp']) : undefined,
    boostDailyRemainingCount: json['boostDailyRemainingCount'],
    boostDailyLimitCount: json['boostDailyLimitCount'],
    openTime: PrexTimestamp_fromJsonValue(json['openTime']),
    options: json['options'].map((x: any) => PositionOption_fromJsonValue(x)),
  };
}
export function Position_toJsonValue(value: Position): PositionJsonValue {
  return {
    'accountId': value.accountId,
    'positionId': value.positionId,
    'symbol': Symbol_toJsonValue(value.symbol),
    'slot': value.slot,
    'marginType': MarginType_toJsonValue(value.marginType),
    'cumFee': PrexDecimal_toJsonValue(value.cumFee),
    'cumFundingFee': PrexDecimal_toJsonValue(value.cumFundingFee),
    'cumTradingFee': PrexDecimal_toJsonValue(value.cumTradingFee),
    'initLeverage': value.initLeverage,
    'effectiveLeverage': PrexDecimal_toJsonValue(value.effectiveLeverage),
    'initPositionMargin': PrexDecimal_toJsonValue(value.initPositionMargin),
    'initMarginReserved': PrexDecimal_toJsonValue(value.initMarginReserved),
    'isolatedMarginInitial': PrexDecimal_toJsonValue(value.isolatedMarginInitial),
    'isolatedMarginAdded': PrexDecimal_toJsonValue(value.isolatedMarginAdded),
    'isolatedMarginRealizedFee': PrexDecimal_toJsonValue(value.isolatedMarginRealizedFee),
    'isolatedMarginExecutedFee': PrexDecimal_toJsonValue(value.isolatedMarginExecutedFee),
    'position': PrexDecimal_toJsonValue(value.position),
    'avgEntryPrice': PrexDecimal_toJsonValue(value.avgEntryPrice),
    'liquidationPrice': value.liquidationPrice != null ? PrexDecimal_toJsonValue(value.liquidationPrice) : undefined,
    'unrealizedPnl': PrexDecimal_toJsonValue(value.unrealizedPnl),
    'unrealizedPnlMark': PrexDecimal_toJsonValue(value.unrealizedPnlMark),
    'unrealizedPnlLast': PrexDecimal_toJsonValue(value.unrealizedPnlLast),
    'unrealizedPnlBbo': PrexDecimal_toJsonValue(value.unrealizedPnlBbo),
    'grossRealizedPnl': PrexDecimal_toJsonValue(value.grossRealizedPnl),
    'netRealizedPnl': PrexDecimal_toJsonValue(value.netRealizedPnl),
    'netPnl': PrexDecimal_toJsonValue(value.netPnl),
    'netPnlMark': PrexDecimal_toJsonValue(value.netPnlMark),
    'netPnlLast': PrexDecimal_toJsonValue(value.netPnlLast),
    'netPnlBbo': PrexDecimal_toJsonValue(value.netPnlBbo),
    'midPrice': PrexDecimal_toJsonValue(value.midPrice),
    'bidPrice': PrexDecimal_toJsonValue(value.bidPrice),
    'askPrice': PrexDecimal_toJsonValue(value.askPrice),
    'bboPriceTimestamp': PrexTimestamp_toJsonValue(value.bboPriceTimestamp),
    'flipComboCount': value.flipComboCount,
    'airdropType': value.airdropType != null ? PositionAirdropType_toJsonValue(value.airdropType) : undefined,
    'lockedUntil': value.lockedUntil != null ? PrexTimestamp_toJsonValue(value.lockedUntil) : undefined,
    'pnlTopPercentile': value.pnlTopPercentile != null ? value.pnlTopPercentile : undefined,
    'boostCumPnl': PrexDecimal_toJsonValue(value.boostCumPnl),
    'buyableBoosts': value.buyableBoosts.map((x: any) => ProfitBoost_toJsonValue(x)),
    'boostExpiryTimestamp': value.boostExpiryTimestamp != null ? PrexTimestamp_toJsonValue(value.boostExpiryTimestamp) : undefined,
    'boostDailyRemainingCount': value.boostDailyRemainingCount,
    'boostDailyLimitCount': value.boostDailyLimitCount,
    'openTime': PrexTimestamp_toJsonValue(value.openTime),
    'options': value.options.map((x: any) => PositionOption_toJsonValue(x)),
  };
}

export interface PositionDelta {
  accountId?: number;
  positionId?: string;
  symbol?: Symbol;
  slot?: number;
  marginType?: MarginType;
  cumFee?: PrexDecimal;
  initLeverage?: number;
  effectiveLeverage?: PrexDecimal;
  initPositionMargin?: PrexDecimal;
  initMarginReserved?: PrexDecimal;
  isolatedMarginInitial?: PrexDecimal;
  isolatedMarginAdded?: PrexDecimal;
  isolatedMarginRealizedFee?: PrexDecimal;
  isolatedMarginExecutedFee?: PrexDecimal;
  position?: PrexDecimal;
  avgEntryPrice?: PrexDecimal;
  liquidationPrice?: PrexDecimal;
  unrealizedPnl?: PrexDecimal;
  unrealizedPnlMark?: PrexDecimal;
  unrealizedPnlLast?: PrexDecimal;
  unrealizedPnlBbo?: PrexDecimal;
  netPnlMark?: PrexDecimal;
  netPnlLast?: PrexDecimal;
  netPnlBbo?: PrexDecimal;
  midPrice?: PrexDecimal;
  bidPrice?: PrexDecimal;
  askPrice?: PrexDecimal;
  bboPriceTimestamp?: PrexTimestamp;
  flipComboCount?: number;
  airdropType?: PositionAirdropType;
  lockedUntil?: PrexTimestamp;
  pnlTopPercentile?: number;
  boostCumPnl?: PrexDecimal;
  buyableBoosts?: ProfitBoost[];
  boostExpiryTimestamp?: PrexTimestamp;
  boostDailyRemainingCount?: number;
  boostDailyLimitCount?: number;
  openTime?: PrexTimestamp;
}
export interface PositionDeltaJsonValue {
  accountId?: number;
  positionId?: string;
  symbol?: SymbolJsonValue;
  slot?: number;
  marginType?: MarginTypeJsonValue;
  cumFee?: PrexDecimalJsonValue;
  initLeverage?: number;
  effectiveLeverage?: PrexDecimalJsonValue;
  initPositionMargin?: PrexDecimalJsonValue;
  initMarginReserved?: PrexDecimalJsonValue;
  isolatedMarginInitial?: PrexDecimalJsonValue;
  isolatedMarginAdded?: PrexDecimalJsonValue;
  isolatedMarginRealizedFee?: PrexDecimalJsonValue;
  isolatedMarginExecutedFee?: PrexDecimalJsonValue;
  position?: PrexDecimalJsonValue;
  avgEntryPrice?: PrexDecimalJsonValue;
  liquidationPrice?: PrexDecimalJsonValue;
  unrealizedPnl?: PrexDecimalJsonValue;
  unrealizedPnlMark?: PrexDecimalJsonValue;
  unrealizedPnlLast?: PrexDecimalJsonValue;
  unrealizedPnlBbo?: PrexDecimalJsonValue;
  netPnlMark?: PrexDecimalJsonValue;
  netPnlLast?: PrexDecimalJsonValue;
  netPnlBbo?: PrexDecimalJsonValue;
  midPrice?: PrexDecimalJsonValue;
  bidPrice?: PrexDecimalJsonValue;
  askPrice?: PrexDecimalJsonValue;
  bboPriceTimestamp?: PrexTimestampJsonValue;
  flipComboCount?: number;
  airdropType?: PositionAirdropTypeJsonValue;
  lockedUntil?: PrexTimestampJsonValue;
  pnlTopPercentile?: number;
  boostCumPnl?: PrexDecimalJsonValue;
  buyableBoosts?: ProfitBoostJsonValue[];
  boostExpiryTimestamp?: PrexTimestampJsonValue;
  boostDailyRemainingCount?: number;
  boostDailyLimitCount?: number;
  openTime?: PrexTimestampJsonValue;
}
export function PositionDelta_fromJsonValue(json: PositionDeltaJsonValue): PositionDelta {
  return {
    accountId: json['accountId'] != null ? json['accountId'] : undefined,
    positionId: json['positionId'] != null ? json['positionId'] : undefined,
    symbol: json['symbol'] != null ? Symbol_fromJsonValue(json['symbol']) : undefined,
    slot: json['slot'] != null ? json['slot'] : undefined,
    marginType: json['marginType'] != null ? MarginType_fromJsonValue(json['marginType']) : undefined,
    cumFee: json['cumFee'] != null ? PrexDecimal_fromJsonValue(json['cumFee']) : undefined,
    initLeverage: json['initLeverage'] != null ? json['initLeverage'] : undefined,
    effectiveLeverage: json['effectiveLeverage'] != null ? PrexDecimal_fromJsonValue(json['effectiveLeverage']) : undefined,
    initPositionMargin: json['initPositionMargin'] != null ? PrexDecimal_fromJsonValue(json['initPositionMargin']) : undefined,
    initMarginReserved: json['initMarginReserved'] != null ? PrexDecimal_fromJsonValue(json['initMarginReserved']) : undefined,
    isolatedMarginInitial: json['isolatedMarginInitial'] != null ? PrexDecimal_fromJsonValue(json['isolatedMarginInitial']) : undefined,
    isolatedMarginAdded: json['isolatedMarginAdded'] != null ? PrexDecimal_fromJsonValue(json['isolatedMarginAdded']) : undefined,
    isolatedMarginRealizedFee: json['isolatedMarginRealizedFee'] != null ? PrexDecimal_fromJsonValue(json['isolatedMarginRealizedFee']) : undefined,
    isolatedMarginExecutedFee: json['isolatedMarginExecutedFee'] != null ? PrexDecimal_fromJsonValue(json['isolatedMarginExecutedFee']) : undefined,
    position: json['position'] != null ? PrexDecimal_fromJsonValue(json['position']) : undefined,
    avgEntryPrice: json['avgEntryPrice'] != null ? PrexDecimal_fromJsonValue(json['avgEntryPrice']) : undefined,
    liquidationPrice: json['liquidationPrice'] != null ? PrexDecimal_fromJsonValue(json['liquidationPrice']) : undefined,
    unrealizedPnl: json['unrealizedPnl'] != null ? PrexDecimal_fromJsonValue(json['unrealizedPnl']) : undefined,
    unrealizedPnlMark: json['unrealizedPnlMark'] != null ? PrexDecimal_fromJsonValue(json['unrealizedPnlMark']) : undefined,
    unrealizedPnlLast: json['unrealizedPnlLast'] != null ? PrexDecimal_fromJsonValue(json['unrealizedPnlLast']) : undefined,
    unrealizedPnlBbo: json['unrealizedPnlBbo'] != null ? PrexDecimal_fromJsonValue(json['unrealizedPnlBbo']) : undefined,
    netPnlMark: json['netPnlMark'] != null ? PrexDecimal_fromJsonValue(json['netPnlMark']) : undefined,
    netPnlLast: json['netPnlLast'] != null ? PrexDecimal_fromJsonValue(json['netPnlLast']) : undefined,
    netPnlBbo: json['netPnlBbo'] != null ? PrexDecimal_fromJsonValue(json['netPnlBbo']) : undefined,
    midPrice: json['midPrice'] != null ? PrexDecimal_fromJsonValue(json['midPrice']) : undefined,
    bidPrice: json['bidPrice'] != null ? PrexDecimal_fromJsonValue(json['bidPrice']) : undefined,
    askPrice: json['askPrice'] != null ? PrexDecimal_fromJsonValue(json['askPrice']) : undefined,
    bboPriceTimestamp: json['bboPriceTimestamp'] != null ? PrexTimestamp_fromJsonValue(json['bboPriceTimestamp']) : undefined,
    flipComboCount: json['flipComboCount'] != null ? json['flipComboCount'] : undefined,
    airdropType: json['airdropType'] != null ? PositionAirdropType_fromJsonValue(json['airdropType']) : undefined,
    lockedUntil: json['lockedUntil'] != null ? PrexTimestamp_fromJsonValue(json['lockedUntil']) : undefined,
    pnlTopPercentile: json['pnlTopPercentile'] != null ? json['pnlTopPercentile'] : undefined,
    boostCumPnl: json['boostCumPnl'] != null ? PrexDecimal_fromJsonValue(json['boostCumPnl']) : undefined,
    buyableBoosts: json['buyableBoosts'] != null ? json['buyableBoosts'].map((x: any) => ProfitBoost_fromJsonValue(x)) : undefined,
    boostExpiryTimestamp: json['boostExpiryTimestamp'] != null ? PrexTimestamp_fromJsonValue(json['boostExpiryTimestamp']) : undefined,
    boostDailyRemainingCount: json['boostDailyRemainingCount'] != null ? json['boostDailyRemainingCount'] : undefined,
    boostDailyLimitCount: json['boostDailyLimitCount'] != null ? json['boostDailyLimitCount'] : undefined,
    openTime: json['openTime'] != null ? PrexTimestamp_fromJsonValue(json['openTime']) : undefined,
  };
}
export function PositionDelta_toJsonValue(value: PositionDelta): PositionDeltaJsonValue {
  return {
    'accountId': value.accountId != null ? value.accountId : undefined,
    'positionId': value.positionId != null ? value.positionId : undefined,
    'symbol': value.symbol != null ? Symbol_toJsonValue(value.symbol) : undefined,
    'slot': value.slot != null ? value.slot : undefined,
    'marginType': value.marginType != null ? MarginType_toJsonValue(value.marginType) : undefined,
    'cumFee': value.cumFee != null ? PrexDecimal_toJsonValue(value.cumFee) : undefined,
    'initLeverage': value.initLeverage != null ? value.initLeverage : undefined,
    'effectiveLeverage': value.effectiveLeverage != null ? PrexDecimal_toJsonValue(value.effectiveLeverage) : undefined,
    'initPositionMargin': value.initPositionMargin != null ? PrexDecimal_toJsonValue(value.initPositionMargin) : undefined,
    'initMarginReserved': value.initMarginReserved != null ? PrexDecimal_toJsonValue(value.initMarginReserved) : undefined,
    'isolatedMarginInitial': value.isolatedMarginInitial != null ? PrexDecimal_toJsonValue(value.isolatedMarginInitial) : undefined,
    'isolatedMarginAdded': value.isolatedMarginAdded != null ? PrexDecimal_toJsonValue(value.isolatedMarginAdded) : undefined,
    'isolatedMarginRealizedFee': value.isolatedMarginRealizedFee != null ? PrexDecimal_toJsonValue(value.isolatedMarginRealizedFee) : undefined,
    'isolatedMarginExecutedFee': value.isolatedMarginExecutedFee != null ? PrexDecimal_toJsonValue(value.isolatedMarginExecutedFee) : undefined,
    'position': value.position != null ? PrexDecimal_toJsonValue(value.position) : undefined,
    'avgEntryPrice': value.avgEntryPrice != null ? PrexDecimal_toJsonValue(value.avgEntryPrice) : undefined,
    'liquidationPrice': value.liquidationPrice != null ? PrexDecimal_toJsonValue(value.liquidationPrice) : undefined,
    'unrealizedPnl': value.unrealizedPnl != null ? PrexDecimal_toJsonValue(value.unrealizedPnl) : undefined,
    'unrealizedPnlMark': value.unrealizedPnlMark != null ? PrexDecimal_toJsonValue(value.unrealizedPnlMark) : undefined,
    'unrealizedPnlLast': value.unrealizedPnlLast != null ? PrexDecimal_toJsonValue(value.unrealizedPnlLast) : undefined,
    'unrealizedPnlBbo': value.unrealizedPnlBbo != null ? PrexDecimal_toJsonValue(value.unrealizedPnlBbo) : undefined,
    'netPnlMark': value.netPnlMark != null ? PrexDecimal_toJsonValue(value.netPnlMark) : undefined,
    'netPnlLast': value.netPnlLast != null ? PrexDecimal_toJsonValue(value.netPnlLast) : undefined,
    'netPnlBbo': value.netPnlBbo != null ? PrexDecimal_toJsonValue(value.netPnlBbo) : undefined,
    'midPrice': value.midPrice != null ? PrexDecimal_toJsonValue(value.midPrice) : undefined,
    'bidPrice': value.bidPrice != null ? PrexDecimal_toJsonValue(value.bidPrice) : undefined,
    'askPrice': value.askPrice != null ? PrexDecimal_toJsonValue(value.askPrice) : undefined,
    'bboPriceTimestamp': value.bboPriceTimestamp != null ? PrexTimestamp_toJsonValue(value.bboPriceTimestamp) : undefined,
    'flipComboCount': value.flipComboCount != null ? value.flipComboCount : undefined,
    'airdropType': value.airdropType != null ? PositionAirdropType_toJsonValue(value.airdropType) : undefined,
    'lockedUntil': value.lockedUntil != null ? PrexTimestamp_toJsonValue(value.lockedUntil) : undefined,
    'pnlTopPercentile': value.pnlTopPercentile != null ? value.pnlTopPercentile : undefined,
    'boostCumPnl': value.boostCumPnl != null ? PrexDecimal_toJsonValue(value.boostCumPnl) : undefined,
    'buyableBoosts': value.buyableBoosts != null ? value.buyableBoosts.map((x: any) => ProfitBoost_toJsonValue(x)) : undefined,
    'boostExpiryTimestamp': value.boostExpiryTimestamp != null ? PrexTimestamp_toJsonValue(value.boostExpiryTimestamp) : undefined,
    'boostDailyRemainingCount': value.boostDailyRemainingCount != null ? value.boostDailyRemainingCount : undefined,
    'boostDailyLimitCount': value.boostDailyLimitCount != null ? value.boostDailyLimitCount : undefined,
    'openTime': value.openTime != null ? PrexTimestamp_toJsonValue(value.openTime) : undefined,
  };
}

export interface PositionTableUpdates {
  s?: Record<PositionKey, Position>;
  u?: Record<PositionKey, PositionDelta>;
  i?: Record<PositionKey, Position>;
  d?: Record<PositionKey, unknown>;
}
export interface PositionTableUpdatesJsonValue {
  s?: Record<PositionKey, PositionJsonValue>;
  u?: Record<PositionKey, PositionDeltaJsonValue>;
  i?: Record<PositionKey, PositionJsonValue>;
  d?: Record<PositionKey, unknown>;
}
export function PositionTableUpdates_fromJsonValue(json: PositionTableUpdatesJsonValue): PositionTableUpdates {
  return {
    s: json['s'] != null ? Object.fromEntries(Object.entries(json['s']).map(([k, v]) => [k, Position_fromJsonValue(v)])) : undefined,
    u: json['u'] != null ? Object.fromEntries(Object.entries(json['u']).map(([k, v]) => [k, PositionDelta_fromJsonValue(v)])) : undefined,
    i: json['i'] != null ? Object.fromEntries(Object.entries(json['i']).map(([k, v]) => [k, Position_fromJsonValue(v)])) : undefined,
    d: json['d'] != null ? json['d'] : undefined,
  };
}
export function PositionTableUpdates_toJsonValue(value: PositionTableUpdates): PositionTableUpdatesJsonValue {
  return {
    's': value.s != null ? Object.fromEntries(Object.entries(value.s).map(([k, v]) => [k, Position_toJsonValue(v)])) : undefined,
    'u': value.u != null ? Object.fromEntries(Object.entries(value.u).map(([k, v]) => [k, PositionDelta_toJsonValue(v)])) : undefined,
    'i': value.i != null ? Object.fromEntries(Object.entries(value.i).map(([k, v]) => [k, Position_toJsonValue(v)])) : undefined,
    'd': value.d != null ? value.d : undefined,
  };
}

export interface AccountPositionTableUpdates {
  s?: Record<AccountPositionKey, Position>;
  u?: Record<AccountPositionKey, PositionDelta>;
  i?: Record<AccountPositionKey, Position>;
  d?: Record<AccountPositionKey, unknown>;
}
export interface AccountPositionTableUpdatesJsonValue {
  s?: Record<AccountPositionKey, PositionJsonValue>;
  u?: Record<AccountPositionKey, PositionDeltaJsonValue>;
  i?: Record<AccountPositionKey, PositionJsonValue>;
  d?: Record<AccountPositionKey, unknown>;
}
export function AccountPositionTableUpdates_fromJsonValue(json: AccountPositionTableUpdatesJsonValue): AccountPositionTableUpdates {
  return {
    s: json['s'] != null ? Object.fromEntries(Object.entries(json['s']).map(([k, v]) => [k, Position_fromJsonValue(v)])) : undefined,
    u: json['u'] != null ? Object.fromEntries(Object.entries(json['u']).map(([k, v]) => [k, PositionDelta_fromJsonValue(v)])) : undefined,
    i: json['i'] != null ? Object.fromEntries(Object.entries(json['i']).map(([k, v]) => [k, Position_fromJsonValue(v)])) : undefined,
    d: json['d'] != null ? json['d'] : undefined,
  };
}
export function AccountPositionTableUpdates_toJsonValue(value: AccountPositionTableUpdates): AccountPositionTableUpdatesJsonValue {
  return {
    's': value.s != null ? Object.fromEntries(Object.entries(value.s).map(([k, v]) => [k, Position_toJsonValue(v)])) : undefined,
    'u': value.u != null ? Object.fromEntries(Object.entries(value.u).map(([k, v]) => [k, PositionDelta_toJsonValue(v)])) : undefined,
    'i': value.i != null ? Object.fromEntries(Object.entries(value.i).map(([k, v]) => [k, Position_toJsonValue(v)])) : undefined,
    'd': value.d != null ? value.d : undefined,
  };
}

export interface ProfitBoost {
  cost: PrexDecimal;
  costDiscounted?: PrexDecimal;
  durationInMin: number;
}
export interface ProfitBoostJsonValue {
  cost: PrexDecimalJsonValue;
  costDiscounted?: PrexDecimalJsonValue;
  durationInMin: number;
}
export function ProfitBoost_fromJsonValue(json: ProfitBoostJsonValue): ProfitBoost {
  return {
    cost: PrexDecimal_fromJsonValue(json['cost']),
    costDiscounted: json['costDiscounted'] != null ? PrexDecimal_fromJsonValue(json['costDiscounted']) : undefined,
    durationInMin: json['durationInMin'],
  };
}
export function ProfitBoost_toJsonValue(value: ProfitBoost): ProfitBoostJsonValue {
  return {
    'cost': PrexDecimal_toJsonValue(value.cost),
    'costDiscounted': value.costDiscounted != null ? PrexDecimal_toJsonValue(value.costDiscounted) : undefined,
    'durationInMin': value.durationInMin,
  };
}

export interface PositionOption {
  direction: PositionOptionDirection;
  strike: PrexDecimal;
  qty: PrexDecimal;
}
export interface PositionOptionJsonValue {
  direction: PositionOptionDirectionJsonValue;
  strike: PrexDecimalJsonValue;
  qty: PrexDecimalJsonValue;
}
export function PositionOption_fromJsonValue(json: PositionOptionJsonValue): PositionOption {
  return {
    direction: PositionOptionDirection_fromJsonValue(json['direction']),
    strike: PrexDecimal_fromJsonValue(json['strike']),
    qty: PrexDecimal_fromJsonValue(json['qty']),
  };
}
export function PositionOption_toJsonValue(value: PositionOption): PositionOptionJsonValue {
  return {
    'direction': PositionOptionDirection_toJsonValue(value.direction),
    'strike': PrexDecimal_toJsonValue(value.strike),
    'qty': PrexDecimal_toJsonValue(value.qty),
  };
}

export type PositionOptionDirection =
  | 'Invalid'
  | 'Call'
  | 'Put';
export type PositionOptionDirectionJsonValue = PositionOptionDirection;
export const PositionOptionDirection_values: PositionOptionDirection[] = ['Invalid', 'Call', 'Put'];
export function PositionOptionDirection_fromJsonValue(json: PositionOptionDirectionJsonValue): PositionOptionDirection {
  return json as PositionOptionDirection;
}
export function PositionOptionDirection_toJsonValue(value: PositionOptionDirection): PositionOptionDirectionJsonValue {
  return value;
}

export type MarginType =
  | 'Isolated'
  | 'Cross';
export type MarginTypeJsonValue = MarginType;
export const MarginType_values: MarginType[] = ['Isolated', 'Cross'];
export function MarginType_fromJsonValue(json: MarginTypeJsonValue): MarginType {
  return json as MarginType;
}
export function MarginType_toJsonValue(value: MarginType): MarginTypeJsonValue {
  return value;
}

export type PositionAirdropType =
  | 'Launch'
  | 'Manual';
export type PositionAirdropTypeJsonValue = PositionAirdropType;
export const PositionAirdropType_values: PositionAirdropType[] = ['Launch', 'Manual'];
export function PositionAirdropType_fromJsonValue(json: PositionAirdropTypeJsonValue): PositionAirdropType {
  return json as PositionAirdropType;
}
export function PositionAirdropType_toJsonValue(value: PositionAirdropType): PositionAirdropTypeJsonValue {
  return value;
}
